import { render, staticRenderFns } from "./NetworkChildren.vue?vue&type=template&id=35c224da&scoped=true"
import script from "./NetworkChildren.vue?vue&type=script&lang=js"
export * from "./NetworkChildren.vue?vue&type=script&lang=js"
import style0 from "./NetworkChildren.vue?vue&type=style&index=0&id=35c224da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c224da",
  null
  
)

export default component.exports